export class BankInformation {
  id?: string = '';
  titulaire_compte: string = '';
  iban: string = '';
  bic_swift: string = '';
  type_iban: string = 'prestation';
  nom_banque: string = '';
}
